import React, { useState, useEffect } from 'react';

const Header = (props) => {

	// * state
	const [text, setText] = useState("Disclaimer Tool");

	// * component mount/update
	useEffect(
		() => {
			setText(props.text); 
		},
		[props.text]
	); 

	// * render 
	return (
		<h1>{text}</h1>
	)

}

export default Header;
